import React, { useState } from "react";
import HowToUse from "./HowToUse";
import Footer from "./Footer";
import OrderForm from "./OrderForm";
import "./ProductGallery.css";
import "./DetoxPage.css";

const detoxProduct = {
  id: "detox-powder",
  src: "/assets/8.png",
  alt: "Natural detox powder pack",
  title: "Detox Powder",
  subtitle: "300 grams",
  price: "₹1,200",
  packSize: "300g",
  details:
    "A premium detox powder blend designed to support digestion, elimination, and gentle cleansing.",
};

function parsePrice(price) {
  const match = String(price).replace(/,/g, "").match(/\d+(?:\.\d+)?/);
  return match ? Number(match[0]) : 0;
}

function formatCurrency(value) {
  return `₹${value.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
}

export default function DetoxPage({ onHome, onAddToCart }) {
  const [quantity, setQuantity] = useState(1);

  const handleAddToCart = (event) => {
    event.stopPropagation();
    onAddToCart?.(detoxProduct, quantity);
  };

  const handleOrderNow = (event) => {
    event.stopPropagation();
    document.getElementById("order")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const increment = () => setQuantity((prev) => prev + 1);
  const decrement = () => setQuantity((prev) => Math.max(1, prev - 1));

  return (
    <div className="detox-page">
      <section className="detox-hero">
        <button className="detox-back-btn" onClick={onHome}>
          <span className="detox-back-arrow">←</span> Back to Home
        </button>

        <div className="detox-hero-content">
          <div className="detox-hero-badge">🌿 Detox Wellness Collection</div>
          <h1 className="detox-hero-title">Detox Powder</h1>
          <p className="detox-hero-sub">
            Natural detox support for digestion, cleansing, and balanced energy.
          </p>
        </div>
      </section>

      <section className="detox-products">
        <div className="detox-products-head">
          <span className="section-eyebrow">Detox Product</span>
          <h2 className="section-title">Detox Powder</h2>
          <p className="section-sub">
            A carefully crafted detox powder with herbal ingredients for daily
            wellness.
          </p>
        </div>

        <div className="detox-product-grid">
          <article className="gallery-card">
            <div className="gallery-img-wrap">
              <img
                src={`${process.env.PUBLIC_URL}${detoxProduct.src}`}
                alt={detoxProduct.alt}
                className="gallery-image"
                loading="lazy"
              />
            </div>

            <div className="gallery-card-body">
              <div className="product-title-row">
                <span className="product-title">{detoxProduct.title}</span>
                <span className="product-packsize">{detoxProduct.subtitle}</span>
              </div>
              <div className="price-block">
                <div className="price-wrap">
                  <div className="price-row">
                    <span className="original-price">{formatCurrency(Math.round(parsePrice(detoxProduct.price) * 1.25))}</span>
                    <span className="discount-price">{formatCurrency(parsePrice(detoxProduct.price))}</span>
                  </div>
                  <div className="price-meta">
                    <span className="discount-badge">20% OFF</span>
                    <span className="save-amount">Save {formatCurrency(Math.round(parsePrice(detoxProduct.price) * 0.25))}</span>
                  </div>
                </div>
              </div>
              <p className="details-copy">{detoxProduct.details}</p>

              <div className="card-bottom-row">
                <div className="quantity-control">
                  <button
                    type="button"
                    className="quantity-btn"
                    onClick={decrement}
                    aria-label="Decrease quantity"
                  >
                    −
                  </button>
                  <span className="quantity-value">{quantity}</span>
                  <button
                    type="button"
                    className="quantity-btn"
                    onClick={increment}
                    aria-label="Increase quantity"
                  >
                    +
                  </button>
                </div>
                <div className="card-action-stack">
                  <button
                    type="button"
                    className="product-add-cart-btn"
                    onClick={handleAddToCart}
                  >
                    + Add to Cart
                  </button>
                  <button
                    type="button"
                    className="product-order-btn"
                    onClick={handleOrderNow}
                  >
                    Order Now
                  </button>
                </div>
              </div>
            </div>
          </article>
        </div>
      </section>

      <HowToUse />

      <OrderForm
        selectedProduct={detoxProduct}
        onOrderPlaced={() => {}}
        totalSales={0}
      />

      <Footer />
    </div>
  );
}
